// hooks/useLoginHandler.js
import { useState } from 'react'
import useRequest from '../../../hooks/useRequest'
import { LogoutHandler } from '../../../helper/Request'
import { saveLS } from '../../../helper/LocalStorage'
import logRedirect from '../../../helper/RedirectLogger'
import {
	createUserAccess,
	fetchUserDeviceTypeGroups,
} from '../../../helper/UserAccess'

const useLoginHandler = forbiddenTenantsInSearch => {
	const [auth, setAuth] = useState(null)
	const [profile, setProfile] = useState(null)
	const [access, setAccess] = useState(null)
	const [loading, setLoading] = useState(true)
	const { Request } = useRequest()

	const getProfile = async auth => {
		const getProfileRequest = await Request('/Users/Profile', auth.access_token)
		if (!getProfileRequest.ok) {
			LogoutHandler()
			return
		}

		const profile = getProfileRequest.data

		if (profile.username === 'OAuth2') {
			LogoutHandler()
			return
		}

		const { deviceTypeGroups, error: deviceTypeGroupsError } =
			await fetchUserDeviceTypeGroups(Request, auth.access_token, profile.userId)

		if (deviceTypeGroupsError) {
			logRedirect('useLoginHandler', {
				action: 'Device type groups unavailable',
				userId: profile.userId || null,
				status: deviceTypeGroupsError.status,
				reason: deviceTypeGroupsError.reason,
			})
		}

		const userAccess = createUserAccess(profile.roles, deviceTypeGroups)

		auth = {
			...auth,
			tenant_id: auth.tenant_id.filter(
				id => !forbiddenTenantsInSearch.includes(id)
			),
		}

		saveLS('auth', auth)
		setAuth(auth)
		setProfile(profile)
		setAccess(userAccess)
		setLoading(false)
	}

	const LoginHandler = async auth => {
		await getProfile(auth)
	}

	return {
		auth,
		profile,
		access,
		loading,
		LoginHandler,
		setLoading,
	}
}

export default useLoginHandler
